import React, {useState, useRef, useEffect} from 'react';
import {Wrapper, Header, Content, Footer, SumbitForm, checkForEmptyField} from "./Form";
import { LoadingIcon } from '../../supplementary_components/loading_icon';
import { InputFieldDelegate } from './input_fields/inputFieldDelegate';

export const CustomAddForm = ({closePopup, popupData}) =>{
    const [loading, setLoading] = useState({state:false, height:'0'});
    const pageRef = useRef(null);
    useEffect(
        () => {
            if (pageRef != null){
                setLoading({state:false, height:`${pageRef.current.clientHeight}px`})
            }   
        }, [pageRef]
    );
    const changeLoadingState = () => {
        setLoading({state: !loading.state, height: loading.height})
    }

    const sumbitForm = (e) => {
        
        e.preventDefault();
        if(checkForEmptyField(popupData, e))return;
        changeLoadingState();
        popupData.action(e, (success)=>{
            changeLoadingState()
            if(success){
                closePopup()
            }
        });
    }
    
    return <Wrapper ref={pageRef} >
        <LoadingIcon state={loading.state} height={loading.height} />
        <Header> <span>{popupData.formTitle}</span></Header>
        <Content className="formContent">
            <SumbitForm method={popupData.method} autoComplete="off" id={popupData.name} onSubmit={(e)=>{sumbitForm(e)}} >
                {popupData.columns.map((column, index)=>{
                    
                    return <InputFieldDelegate 
                            index = {index}
                            key={index}
                            column={column}
                            closePopup={closePopup}
                        />
                })}
                
            </SumbitForm>
        </Content>
        <Footer>
            <div className="non-selectable" onClick={()=>{
                if(popupData.skipMethod){
                    closePopup();
                    popupData.skipMethod();
                }else{
                    closePopup()
                }  
            }}>{popupData.skipLabel ? popupData.skipLabel : "Cancel"}</div>
            <div> <input type="submit" form={popupData.name} value={popupData.submitTitle}/></div>
        </Footer>
    </Wrapper>
    
}